import Vue from 'vue';

import '@/styles/quasar.scss';
import 'ui-kit/src/styles/mf-icons.css';
import '@quasar/extras/roboto-font-latin-ext/roboto-font-latin-ext.css';
import { Dialog, Meta, Notify, Quasar } from 'quasar';
import { iconMapFn } from 'ui-kit/src/libs/icons';

Vue.use(Quasar, {
    config: {
        loadingBar: {
            color: 'green',
        },
    },
    plugins: {
        Dialog,
        Meta,
        Notify,
    },
});

Vue.prototype.$q.iconMapFn = iconMapFn;
